import { Component, EventEmitter, Output } from '@angular/core'
import { RouterLink } from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import { NzTableModule } from 'ng-zorro-antd/table'
import { NzUploadComponent, NzUploadFile } from 'ng-zorro-antd/upload'

import { ButtonComponent } from '../../../components/button/button.component'

export interface FileSelectedEvent {
  file: NzUploadFile
  fileLineCount: number
  filePreviewData: string[][] | undefined
}

@Component({
  selector: 'app-step-upload',
  standalone: true,
  imports: [
    TranslatePipe,
    NzUploadComponent,
    SvgIconComponent,
    NzTableModule,
    RouterLink,
    ButtonComponent,
  ],
  templateUrl: './step-upload.component.html',
})
export class StepUploadComponent {
  @Output() public fileSelected = new EventEmitter<FileSelectedEvent>()
  @Output() public stepCompleted = new EventEmitter<void>()

  public file?: NzUploadFile
  public fileLineCount: number = 0
  public filePreviewData?: string[][]

  public readonly lineTerminator = '\n'
  public readonly cellTerminator = ';'

  public beforeUpload = (file: NzUploadFile): boolean => {
    this.file = file
    this.readFile()
    return false
  }

  public uploadSubmit(): void {
    this.fileSelected.emit({
      file: this.file!,
      fileLineCount: this.fileLineCount,
      filePreviewData: this.filePreviewData,
    })
    this.stepCompleted.emit()
  }

  private readFile(): void {
    const blob = this.file as Blob | undefined
    if (!blob) return

    blob.text().then((text) => {
      this.filePreviewData = text
        .split(this.lineTerminator, 11)
        .map((value) => value.split(this.cellTerminator))

      const lineRegex = new RegExp(this.lineTerminator, 'g')
      let lineCount = 0
      while (lineRegex.exec(text.trim()) !== null) lineCount++
      this.fileLineCount = lineCount
    })
  }
}
